// src/redux/actions/leadActions.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import api from './configApi';

// Definindo a ação assíncrona usando createAsyncThunk
export const enviarEmail = createAsyncThunk(
  'email/enviarEmail',
  async (id, thunkAPI) => {
    try {
      // Substitua a URL abaixo pela sua endpoint de API real
      const response = await api.post(`proposals/send-email/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const enviarEmailDadosBancarios = createAsyncThunk(
  'email/enviarEmail',
  async (id, thunkAPI) => {
    try {
      // Substitua a URL abaixo pela sua endpoint de API real
      const response = await api.post(`proposals/send-email-dados-bac/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
